import React from "react";
import { Flex } from "@chakra-ui/react";
import {
  AuthHeading,
  AuthSubheading,
} from "@root/commonStyles/commonStyle";
import { useBrandingContext } from "@root/context/branding-context";
import { useTranslation } from "react-i18next";

export const LoginBrandingTitle: React.FC = () => {
  const { branding } = useBrandingContext();
  const { t } = useTranslation("common");

  return (
    <Flex direction="column" align="stretch" width="100%" gap="10px">
      <AuthHeading>
        {branding?.loginPage?.welcomeMessage || t("login.subTitle")}
      </AuthHeading>
      <AuthSubheading>{t("login.subtitle_1")}</AuthSubheading>
    </Flex>
  );
};
